import { IPublicClientApplication, PublicClientApplication, BrowserCacheLocation } from '@azure/msal-browser';
import { MicrosoftConfigService } from './microsoft-config-service';

export function MSALInstanceFactory(configService: MicrosoftConfigService): IPublicClientApplication {
  // If the DB call failed, provide a fallback or throw an error
  if (!configService.clientId) {
    console.warn("MSAL Client ID not found, using placeholder.");
  }

  return new PublicClientApplication({
    auth: {
      clientId: configService?.clientId || '00000000-0000-0000-0000-000000000000',
      authority: `https://login.microsoftonline.com/${configService?.authority}`,
      redirectUri: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
      navigateToLoginRequestUrl: false
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
    }
  });
}